import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-3 custom-border rounded bg-primary-subtle" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "pi pi-question-circle me-2 align-middle" }, null, -1)
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "pi pi-question-circle me-2 align-middle" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (this.routeDoc !== null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_router_link, {
              to: {name: this.routeDoc},
              class: "align-middle",
              style: {"text-decoration":"none"},
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _hoisted_3,
                _renderSlot(_ctx.$slots, "default")
              ]),
              _: 3
            }, 8, ["to"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _renderSlot(_ctx.$slots, "default")
          ])),
      _renderSlot(_ctx.$slots, "content")
    ])
  ]))
}